/* eslint-disable no-useless-escape */
/* eslint-disable no-restricted-globals */
const validator = {};
const rules = {
  englishOnly: {
    handler(value) {
      if (value === null || value === undefined || value === '') return true;
      return /^[a-zA-Z0-9\s\-'.]+$/.test(value);
    },
    errorMessage: 'يجب أن يحتوي هذا الحقل على أحرف إنجليزية فقط'
  },
  arabicOnly: {
    handler(value) {
      if (value === null || value === undefined || value === '') return true;
      return /^[\u0600-\u06FF0-9\s\-'.]+$/.test(value);
    },
    errorMessage: 'يجب أن يحتوي هذا الحقل على أحرف عربية فقط'
  },
  emailArabic: {
    handler(value) {
      if (value === null || value === undefined || value === '') return true;
      // eslint-disable no-useless-escape
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(value).toLowerCase());
    },
    errorMessage: 'بريد إلكتروني غير صالح'
  },
  email: {
    handler(value) {
      if (value === null || value === undefined || value === '') return true;
      // eslint-disable no-useless-escape
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(value).toLowerCase());
    },
    errorMessage: 'Invalid email'
  },
  number: {
    handler(value) {
      if (value === null || value === undefined || value === '') {
        return true;
      }

      // Allowing integer and float
      return !isNaN(value);
    },
    errorMessage: 'Invalid number'
  },
  notEmpty: {
    handler(value) {
      return value !== null && value !== undefined && value.length !== 0;
    },
    errorMessage: 'هذا الحقل لا يمكن أن يكون فارغاً'
  },
  noWhiteSpace: {
    handler(value) {
      return !/\s/g.test(value);
    },
    errorMessage: 'No whitespace allowed'
  },
  noSpecialChar: {
    handler(value) {
      // eslint-disable-next-line no-useless-escape
      return !/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value);
    },
    errorMessage: 'No special character allowed'
  },
  maxPercentage: {
    handler(value) {
      if (!value || value === '') return true; // Allow empty if not required

      const amount = parseFloat(value);

      // Check if it's a valid number and doesn't exceed 100
      if (isNaN(amount) || amount < 0 || amount > 100) return false;

      return true;
    },
    errorMessage: 'قيمة الخصم بالنسبة المئوية يجب أن تكون بين 0 و 100'
  },
  endDateAfterStart: {
    handler(value) {
      if (!value) return true; // Allow empty if not required

      const startDateInput = document.querySelector('input[name="start_date"]');
      const startDate = startDateInput?.value;

      // Get today's date at midnight for comparison
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const endDateObj = new Date(value);
      endDateObj.setHours(0, 0, 0, 0);

      // Check if end date is in the past
      if (endDateObj < today) {
        return false;
      }

      if (!startDate) return true; // If no start date, only check past validation

      const startDateObj = new Date(startDate);
      startDateObj.setHours(0, 0, 0, 0);

      // End date must be > start date
      return endDateObj > startDateObj;
    },
    errorMessage:
      'يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء وألا يكون قبل اليوم'
  },
  startDateBeforeEnd: {
    handler(value) {
      if (!value) return true;

      // Get today's date at midnight for comparison
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const startDateObj = new Date(value);
      startDateObj.setHours(0, 0, 0, 0);

      // Check if start date is in the past
      if (startDateObj < today) {
        return false;
      }

      const endDateInput = document.querySelector('input[name="end_date"]');
      const endDate = endDateInput?.value;

      if (!endDate) return true; // If no end date, only check past validation

      const endDateObj = new Date(endDate);
      endDateObj.setHours(0, 0, 0, 0);

      // Start date must be < end date
      if (startDateObj >= endDateObj) {
        // Trigger re-validation of end date field
        setTimeout(() => {
          if (endDateInput) {
            endDateInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, 0);
        return false;
      }

      return true;
    },
    errorMessage:
      'يجب أن يكون تاريخ البدء اليوم أو لاحقًا وأن يكون قبل تاريخ الانتهاء'
  },
  maxUsesPerCustomerValidation: {
    handler(value) {
      if (!value || value === '') return true; // Allow empty

      const perCustomer = parseInt(value, 10);

      // If it's not a valid number, let the number rule handle it
      if (isNaN(perCustomer)) return true;
      if (perCustomer < 0) return false;

      // Get the max uses per coupon value
      const maxUsesPerCouponInput = document.querySelector(
        'input[name="max_uses_time_per_coupon"]'
      );
      const maxUsesPerCoupon = maxUsesPerCouponInput?.value;

      if (!maxUsesPerCoupon || maxUsesPerCoupon === '') return true;

      const perCoupon = parseInt(maxUsesPerCoupon, 10);

      if (isNaN(perCoupon)) return true;

      // Max uses per customer must be <= max uses per coupon
      return perCustomer <= perCoupon;
    },
    errorMessage:
      'لا يمكن أن يتجاوز الحد الأقصى لاستخدامات العميل الواحد الحد الأقصى لاستخدامات الكوبون'
  },
  maxUsesPerCouponValidation: {
    handler(value) {
      if (!value || value === '') return true;

      const perCoupon = parseInt(value, 10);

      // If it's not a valid number, let the number rule handle it
      if (isNaN(perCoupon)) return true;
      if (perCoupon < 0) return false;

      // Get the max uses per customer value
      const maxUsesPerCustomerInput = document.querySelector(
        'input[name="max_uses_time_per_customer"]'
      );
      const maxUsesPerCustomer = maxUsesPerCustomerInput?.value;

      if (!maxUsesPerCustomer || maxUsesPerCustomer === '') return true;

      const perCustomer = parseInt(maxUsesPerCustomer, 10);

      if (isNaN(perCustomer)) return true;

      // Trigger re-validation of per customer field if needed
      if (perCustomer > perCoupon) {
        setTimeout(() => {
          if (maxUsesPerCustomerInput) {
            maxUsesPerCustomerInput.dispatchEvent(
              new Event('change', { bubbles: true })
            );
          }
        }, 0);
      }

      return true; // This field always passes, the other field shows the error
    },
    errorMessage: 'Invalid value'
  },
  minOrderGreaterThanDiscount: {
    handler(value) {
      if (!value || value === '') return true;

      const minOrderValue = parseFloat(value);
      if (isNaN(minOrderValue)) return true;

      // Get the discount amount
      const discountAmountInput = document.querySelector(
        'input[name="discount_amount"]'
      );
      const discountAmount = parseFloat(discountAmountInput?.value);

      if (isNaN(discountAmount)) return true;

      // Get discount type to check if it's fixed
      const discountTypeInput = document.querySelector(
        'input[name="discount_type"]:checked'
      );
      const discountType = discountTypeInput?.value;

      // Only validate for fixed discount types
      if (
        discountType === 'fixed_discount_to_entire_order' ||
        discountType === 'fixed_discount_to_specific_products'
      ) {
        // Minimum Order Value must be > discount amount
        return minOrderValue > discountAmount;
      }

      return true;
    },
    errorMessage: 'Minimum order value must be greater than discount amount'
  },
  triggerMinOrderValidation: {
    handler(value) {
      if (!value || value === '') return true;

      // Trigger re-validation of min_order_value field
      const minOrderInput = document.querySelector(
        'input[name="discount_rules[min_order_value]"]'
      );
      if (minOrderInput) {
        setTimeout(() => {
          minOrderInput.dispatchEvent(new Event('change', { bubbles: true }));
        }, 0);
      }

      return true;
    },
    errorMessage: 'Invalid value'
  },
  englishDescriptionOnly: {
    handler(value) {
      if (!value || value === '') return true;
      let plainText = value;
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          plainText = parsed
            .map((row) =>
              (row.columns || [])
                .map((col) => {
                  if (!col.data || !col.data.blocks) return '';
                  return col.data.blocks
                    .map((block) =>
                      block.data
                        ? block.data.text || block.data.content || ''
                        : ''
                    )
                    .join(' ');
                })
                .join(' ')
            )
            .join(' ');
        }
      } catch (e) {
        plainText = value;
      }
      plainText = plainText
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/&[a-zA-Z#0-9]+;/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      if (!plainText) return true;
      return !/[\u0600-\u06FF]/.test(plainText);
    },
    errorMessage: 'يجب أن يحتوي الوصف على حروف إنجليزية فقط'
  },
  arabicDescriptionOnly: {
    handler(value) {
      if (!value || value === '') return true;
      let plainText = value;
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          plainText = parsed
            .map((row) =>
              (row.columns || [])
                .map((col) => {
                  if (!col.data || !col.data.blocks) return '';
                  return col.data.blocks
                    .map((block) =>
                      block.data
                        ? block.data.text || block.data.content || ''
                        : ''
                    )
                    .join(' ');
                })
                .join(' ')
            )
            .join(' ');
        }
      } catch (e) {
        plainText = value;
      }
      plainText = plainText
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/&[a-zA-Z#0-9]+;/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      if (!plainText) return true;
      const hasArabic = /[\u0600-\u06FF]/.test(plainText);
      const hasEnglish = /[A-Za-z]/.test(plainText);
      return hasArabic && !hasEnglish;
    },
    errorMessage: 'يجب أن يحتوي الوصف على حروف عربية'
  },
  validPrice: {
    handler(value) {
      if (value === null || value === undefined || value === '') return true;
      return /^\d+(\.\d{1,2})?$/.test(String(value));
    },
    errorMessage: 'يجب أن يكون السعر رقماً موجباً'
  },
  validWeight: {
    handler(value) {
      if (value === null || value === undefined || value === '') return true;
      return /^[0-9]+(\.[0-9]{1,2})?$/.test(String(value));
    },
    errorMessage: 'يجب أن يكون الوزن رقماً بحد أقصى رقمين عشريين'
  },
  couponValue: {
    handler(value) {
      if (value === null || value === undefined || value === '') return true;
      // Coupon code: numeric only, no spaces or special characters
      return /^[0-9]+$/.test(String(value));
    },
    errorMessage: 'قيمة الخصم يجب ان تكون ارقاماً فقط'
  },
  greaterThanZero: {
    handler(value) {
      if (value === null || value === undefined || value === '') return true;

      const number = Number(value);

      return !Number.isNaN(number) && number > 0;
    },
    errorMessage: 'قيمة الخصم يجب أن تكون رقماً أكبر من صفر'
  },
  maxDiscountAmount: {
    handler(value) {
      if (value === null || value === undefined || value === '') return true;

      return /^[0-9]+$/.test(String(value)) && Number(value) > 0;
    },
    errorMessage: 'الحد الأقصى لخصم الكوبون يجب أن يكون رقماً أكبر من صفر'
  },
  minOrderValue: {
    handler(value) {
      if (value === null || value === undefined || value === '') return true;

      return /^[0-9]+$/.test(String(value)) && Number(value) >= 0;
    },
    errorMessage: 'الحد الأدنى لقيمة الطلب يجب أن يكون رقماً أكبر من صفر'
  }
};

rules.emailArabic = {
  ...rules.email,
  errorMessage: 'البريد الإلكتروني غير صالح'
};

rules.numberArabic = {
  ...rules.number,
  errorMessage: 'يجب أن تكون القيمة رقماً صالحاً'
};

rules.notEmptyArabic = {
  ...rules.notEmpty,
  errorMessage: 'هذا الحقل لا يمكن أن يكون فارغاً'
};

rules.maxUsesPerCustomerValidationArabic = {
  ...rules.maxUsesPerCustomerValidation,
  errorMessage:
    'لا يمكن أن يتجاوز الحد الأقصى لاستخدامات العميل الواحد الحد الأقصى لاستخدامات الكوبون'
};

rules.maxUsesPerCouponValidationArabic = {
  ...rules.maxUsesPerCouponValidation,
  errorMessage: 'يجب أن يكون الحد الأقصى لاستخدامات الكوبون رقماً صالحاً'
};

validator.addRule = (key, handler, message) => {
  rules[key] = {
    handler,
    errorMessage: message
  };
};

validator.removeRule = (key) => {
  delete rules[key];
};

validator.getRule = (key) => rules[key];

export { validator };
